import styled from "styled-components";

export const HeaderContainer = styled.div`
  background-color: black;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

export const Logo = styled.img`
  height: 60px;
  padding-left: 1em;
  padding-top: 0.5em;
`;

export const NavItems = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const NavItem = styled.div`
  transition: all 500ms ease-in-out;
  color: white;
  letter-spacing: 2px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  padding: 0 2em;

  &:hover {
    background-color: #101012;
    color: white;
  }

  @media (max-width: 900px) {
    display: flex;
    justify-content: left;
    padding-left: 10px;
    width: 100%;
  }
`;
